export enum FeatureToggle {
  receipts = 'rt_receipts',
}
